<template>
  <section class="gj-container" :class="{ 'is-vertical': isVertical }">
    <slot></slot>
  </section>
</template>
<script>
export default {
  name: 'GjContainer',

  componentName: 'GjContainer',

  props: {
    direction: String
  },

  computed: {
    isVertical() {
      if (this.direction === 'vertical') {
        return true;
      } else if (this.direction === 'horizontal') {
        return false;
      }
    }
  }
};

</script>



// WEBPACK FOOTER //
// src/components/container/src/main.vue